import CollaborationService from './CollaborationService';

class CodeSignalService implements CollaborationService {
  readonly name = 'CodeSignal';

  readonly logoUrl = '/static/images/integrations/codesignal.png';
}

export default new CodeSignalService();
